export const TreatmentInstanceStatus = {
  ToDo: 'ToDo',
  InProgress: 'InProgress',
  Done: 'Done',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
  Removed: 'Removed',
  Rescheduled: 'Rescheduled',
  Moved: 'Moved',
};
